import ApiService from './ApiService'

export const WellbeingService = {

  baseURL: process.env.VUE_APP_WELLBEING_URL,

  saveContact(data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/v1/leads/new`, data)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  updateContact(contactId, data) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${this.baseURL}/v1/leads/${contactId}`, data)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  deleteContact(contactId) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/v1/leads/${contactId}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  savePursue(selectedLeadId, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}/v1/pursues/${selectedLeadId}`, data)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },

  deletePursue(pursueId) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${this.baseURL}/v1/pursues/${pursueId}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }

}


